export enum ERROR_MESSAGES {
    NOT_FOUND = 'codeForm.error.notFound',
    REQUIRED = 'codeForm.error.required',
}
